import React, { FC, memo } from 'react';
import styles from './filter-trigger.module.css';
import { Typography } from '~/shared/components';
import { CollapseIcon } from '~/shared/components';

type Props = {
    onClick?: () => void;
    label: string;
    isOpen: boolean;
};

const FilterTrigger: FC<Props> = memo((props) => {
    const { onClick, label, isOpen } = props;
    return (
        <button onClick={onClick} data-open={isOpen} className={styles.root}>
            <Typography as='span' variant='bodySm'>
            {label}
            </Typography>
            <CollapseIcon isOpen={isOpen} size='small'/>
        </button>
    );
});

FilterTrigger.displayName = 'FilterTrigger';
export default FilterTrigger;
